<template>
	<div>
		<!-- Select entity type -->
		<div>
			<div class="xs-12 fw7 lh125 p1" :class="fsLabel">
				{{ $t("select_entity_type") }}
			</div>
			<j-base-select
				:options="entityTypeOptions"
				:size="size"
				:allowSelectNothing="false"
				v-model="entityType"
			/>
		</div>
		<div class="xs-12 fw7 lh125 p1 mt4" :class="fsLabel">
			{{ $t("select_entity") }}
		</div>

		<!-- Select entity -->
		<select-entity
			:entityType="entityType"
			v-model="entityId"
			name="entity"
			:status="errors && errors.first('entity') ? 'error' : null"
			v-validate="'required'"
		/>
		<!-- Error message -->
		<div
			class="xs-12 fs3 lh125 cError mt1"
			v-if="errors && errors.first('entity')"
		>
			{{ errors ? errors.first("entity") : null }}
		</div>

		<!-- Enter relationship type -->
		<div class="xs-12 fw7 lh125 p1 mt4" :class="fsLabel">
			{{ $t("relationship_type") }}
		</div>
		<j-base-input-text
			class="xs-12 fs4"
			:status="errors && errors.first('type') ? 'error' : null"
			name="type"
			:size="size"
			v-model="relationshipType"
			v-validate="'required'"
		/>
		<!-- Error message -->
		<div
			class="xs-12 fs3 lh125 cError mt1"
			v-if="errors && errors.first('type')"
		>
			{{ errors ? errors.first("type") : null }}
		</div>

		<!-- Done button -->
		<div class="mt15 flex xs-center">
			<j-button class="mt4" @click="addRelationship" :isLoading="isLoading">
				{{ $t("done") }}
			</j-button>
		</div>
	</div>
</template>

<script>
import SelectEntity from "./SelectEntity"
import JBaseSelect from "@/components/JBaseSelect/"
import JButton from "@/components/JButton/"
import JBaseInputText from "@/components/JBaseInputText/"
import api from "@/modules/core/api/"

export default {
	name: "EntityAddRelationship",
	components: {
		JBaseSelect,
		JBaseInputText,
		JButton,
		SelectEntity
	},
	props: {
		/**
		 * Size of the form inputs
		 */
		size: {
			validator(val) {
				return ["xsmall", "small", "medium", "large"].includes(val)
			},
			default: "medium"
		},

		fsLabel: { type: String, default: "fs4" },

		// entity id of the client
		sourceId: String
	},

	data() {
		return {
			options: {
				entities: []
			},
			value: "",
			entityId: "",
			entityType: "individual",
			relationshipType: "",
			entityTypeOptions: [
				{ name: "Individual", value: "individual" },
				{ name: "Company", value: "company" },
				{ name: "Object", value: "object" },
				{ name: "Participant", value: "participant" }
			],
			isLoading: false
		}
	},

	methods: {
		async addRelationship() {
			// Validate form
			const isValid = await this.$validator.validate()
			if (!isValid) return

			this.isLoading = true

			const res = await api.addLink({
				linkInput: {
					sourceId: this.sourceId,
					link: this.relationshipType,
					targetId: this.entityId
				}
			})

			this.isLoading = false

			// Error
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
			}

			this.$emit("added")
		}
	}
}
</script>
